import React from 'react';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './App.css';
import { UserContextProvider } from "./context/UserContextProvider";
import AppRouter from "./AppRouter";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <UserContextProvider>
          <AppRouter />
        </UserContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;